module.exports = __webpack_public_path__ + "img/H10084.e323f0c5.png";